/**
 * Published legal text, rendered by LegalDocument.
 * Source: legal_docs/final/OVACS_Terms_and_Conditions.docx, sections 12, 13 and 15 (first publication 4 November 2026).
 * Block kinds: h1, h2, p, b (bullet), table [kind, columnFractions, header, rows].
 * Inline: **bold**; URLs and email addresses become links.
 */
export default {
  title: "OVACS Refund and Cancellation Policy",
  subtitle: "How cancelling and refunds work for OVACS subscriptions",
  lastUpdated: "4 November 2026",
  effectiveDate: "4 November 2026",
  summary: [
    "You can cancel at any time. Your subscription stays active until the end of the period you already paid for.",
    "You can get a full refund if you ask within 14 days of your first payment.",
    "This page summarises sections 12, 13 and 15 of our Terms and Conditions (https://ovacs.com/terms), which apply in full.",
  ],
  blocks: [
    ["h1","1. Cancelling your subscription"],
    ["p","You can cancel at any time from Profile Settings > Plan & Storage in OVACS (through the Stripe billing portal) or by emailing info@ovacs.com."],
    ["p","When you cancel, your subscription stays active until the end of the period you already paid for and does not renew. After that, uploading files, sending voice messages and sending messages with attachments are paused. You can still sign in, view and download your content."],
    ["p","You can undo a cancellation before the paid period ends."],
    ["p","Cancelling your subscription does not delete your account or your content. To delete your account, email info@ovacs.com from your account email."],
    ["h1","2. Free trial"],
    ["p","The free trial needs no payment card and does not turn into a paid subscription by itself, so there is nothing to cancel or refund when a trial ends."],
    ["h1","3. Refunds"],
    ["p","If you are not satisfied, you can ask for a full refund within 14 days of your first payment. Renewal payments are not refunded, except where the law requires."],
    ["p","To ask for a refund, email info@ovacs.com from your account email. Approved refunds go back to the card you paid with, usually within 5 to 10 business days."],
    ["p","Nothing in this policy limits rights you have under consumer-protection laws that apply to you."],
    ["h1","4. Payment disputes"],
    ["p","If you think a charge is wrong, please contact us first at info@ovacs.com and we will try to fix it quickly. If you dispute a valid charge with your bank, we may restrict the workspace while the dispute is open."],
    ["h1","5. Contact us"],
    ["b","Stirring Apps FZE LLC (OVACS)"],
    ["b","Business Centre, Sharjah Publishing City Free Zone, Sharjah, United Arab Emirates"],
    ["b","Email: info@ovacs.com"],
    ["b","Phone: +971 54 235 8420"],
  ],
}
